import { Box } from "@mantine/core";
import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useScrollTopWindow } from "shared/hooks/useSсrollTopWindow";
import { CenterContainer } from "shared/ui/_containers/CenterContainer";
import { MainLoader } from "shared/ui/_loaders/MainLoader";
import { Footer } from "./Footer";
import { Header } from "./Header";

export const Layout = () => {
  const location = useLocation();
  useScrollTopWindow({ dependencies: [location.pathname] });

  return (
    <Suspense
      fallback={
        <CenterContainer>
          <MainLoader />
        </CenterContainer>
      }
    >
      <Header />
      <Box mih={500} component={"main"}>
        <Outlet />
      </Box>
      <Footer />
    </Suspense>
  );
};
